import { filter, isEmpty, values } from 'lodash';
import TrackingCookies from '../TrackingCookies';
import { TrackingMiddleware } from '../types';

const utmParamsMiddleware: TrackingMiddleware = () => async event => {
  const utmTrackParams = TrackingCookies.retrieveUtms();

  if (isEmpty(filter(values(utmTrackParams)))) {
    return;
  }

  event.apply({
    utmTrackParams: {
      campaignName: utmTrackParams.utm_campaign,
      campaignSource: utmTrackParams.utm_source,
      campaignContent: utmTrackParams.utm_content,
      campaignMedium: utmTrackParams.utm_medium,
    },
  });

  event._deprecatedSetProprtiesInRoot(['utmTrackParams']);
};

export default utmParamsMiddleware;
